/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import restClient from '../../app/helpers/restClient';

const RESOURCE_ROOT_FACADE = '/checkout/availability';
const RESOURCE_PAGE_FACADE = '/greeting';

const getGreetingAvailability = ({
    jwtToken, productCode, brandCode, zipCode, locationType, deliveryDate, greetingCardSku,
}) => {
    const env = {
        rootUri: RESOURCE_ROOT_FACADE,
    };
    const resourcePage = RESOURCE_PAGE_FACADE;

    const params = {
        productCode,
        brandCode,
        locationType,
        greetingCardSku,
    };
    if (zipCode)  {
        params.zipCode = zipCode;
    }

    if (deliveryDate)  {
        params.deliveryDate = deliveryDate;
    }

    return restClient.getFacade(env, resourcePage, jwtToken, params)
        .then((response) => response);
};

export default getGreetingAvailability;
